/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferInNote
 */
export interface OfferInNote {
    /**
     * 
     * @type {string}
     * @memberof OfferInNote
     */
    note: string;
}

export function OfferInNoteFromJSON(json: any): OfferInNote {
    return OfferInNoteFromJSONTyped(json, false);
}

export function OfferInNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferInNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function OfferInNoteToJSON(value?: OfferInNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}


